import { AnnotationStatus } from '../../index';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * @hidden
 * PdfLinkAnnotation class for handling programmatic link annotations add, edit and delete
 */
var PdfLinkAnnotation = /** @class */ (function () {
    function PdfLinkAnnotation(pdfviewer, pdfViewerBase) {
        /**
         * @private
         */
        this.isAddAnnotationProgramatically = false;
        /**
         * @private
         */
        this.linkAnnotationCount = 0;
        this.pdfViewer = pdfviewer;
        this.pdfViewerBase = pdfViewerBase;
    }
    /**
     * @param {any} options - It describes about the annotation
     * @param {IPoint} offset - It describes about the offset value of annotation
     * @private
     * @returns {Object} - Object
     */
    PdfLinkAnnotation.prototype.updateAddAnnotationDetails = function (options, offset) {
        if (!options) {
            options = { offset: { x: 10, y: 10 }, pageNumber: 0, width: undefined, height: undefined };
            offset = options.offset;
        }
        else if (!options.offset) {
            offset = { x: 10, y: 10 };
        }
        else {
            offset = options.offset;
        }
        var annotationName = this.pdfViewer.annotation.createGUID();
        options.width = options.width ? options.width : 150;
        options.height = options.height ? options.height : 75;
        var linkAnnotation = [];
        var annotation = {
            AnnotName: annotationName,
            AnnotType: 'link',
            Bounds: {
                X: offset.x, Y: offset.y, Width: options.width,
                Height: options.height, Left: offset.x, Top: offset.y,
                Location: { X: offset.x, Y: offset.y }, Size: {
                    Height: options.height,
                    IsEmpty: false, Width: options.width
                }
            },
            DestinationPageIndex: options.destinationPageIndex,
            DestinationLocation: {
                X: !isNullOrUndefined(options.destinationLocation) ? options.destinationLocation.x : null,
                Y: !isNullOrUndefined(options.destinationLocation) ? options.destinationLocation.y : null
            },
            ZoomValue: options.zoomValue,
            Url: options.url,
            StrokeColor: options.strokeColor ? options.strokeColor : 'transparent',
            Thickness: options.thickness ? options.thickness : 1,
            Subject: options.subject ? options.subject : 'Link',
            Status: AnnotationStatus.NewlyAdded
        };
        linkAnnotation[0] = annotation;
        return { linkAnnotation: linkAnnotation };
    };
    /**
     * @param {any} linkAnnotations - It describes about the link annotation
     * @param {number} pageNumber - It describes about the page number
     * @param {boolean} isImportAcion - It describes about import action
     * @param {boolean} isAnnotOrderAction - It describes about the isAnnotOrderAction
     * @private
     * @returns {void} - void
     */
    PdfLinkAnnotation.prototype.renderLinkAnnotations = function (linkAnnotations, pageNumber, isImportAcion, isAnnotOrderAction) {
        if (linkAnnotations) {
            if (linkAnnotations.length >= 1) {
                var linkAnnots = this.pdfViewer.annotation.getStoredAnnotations(pageNumber, linkAnnotations, '_annotations_link');
                if (!linkAnnots || isAnnotOrderAction || isImportAcion) {
                    for (var i = 0; i < linkAnnotations.length; i++) {
                        var annotation = linkAnnotations[parseInt(i.toString(), 10)];
                        var annotId = annotation.id || annotation.Id || ('link' + (++this.linkAnnotationCount));
                        // Extract bounds values
                        var boundLeft = 0;
                        var boundTop = 0;
                        var boundWidth = 100;
                        var boundHeight = 50;
                        if (annotation.bounds) {
                            boundLeft = annotation.bounds.left || 0;
                            boundTop = annotation.bounds.top || 0;
                            boundWidth = annotation.bounds.width || 100;
                            boundHeight = annotation.bounds.height || 50;
                        }
                        else if (annotation.Bounds) {
                            boundLeft = annotation.Bounds.X || annotation.Bounds.x || 0;
                            boundTop = annotation.Bounds.Y || annotation.Bounds.y || 0;
                            boundWidth = annotation.Bounds.Width || annotation.Bounds.width || 100;
                            boundHeight = annotation.Bounds.Height || annotation.Bounds.height || 50;
                        }
                        var left = !isNullOrUndefined(annotation.DestinationLocation) ?
                            (!isNullOrUndefined(annotation.DestinationLocation.X) ? annotation.DestinationLocation.X :
                                annotation.DestinationLocation.x) : undefined;
                        var top_1 = !isNullOrUndefined(annotation.DestinationLocation) ?
                            (!isNullOrUndefined(annotation.DestinationLocation.Y) ? annotation.DestinationLocation.Y :
                                annotation.DestinationLocation.y) : undefined;
                        var status_1 = void 0;
                        // Create annotation object following shape annotation pattern
                        var linkAnnotation = {
                            id: annotId,
                            shapeAnnotationType: 'Link',
                            annotName: annotation.AnnotName,
                            annotationIndex: annotation.AnnotationIndex,
                            pageNumber: pageNumber,
                            bounds: {
                                left: boundLeft,
                                top: boundTop,
                                width: boundWidth,
                                height: boundHeight,
                                right: boundLeft + boundWidth,
                                bottom: boundTop + boundHeight
                            },
                            destinationPageIndex: annotation.DestinationPageIndex,
                            destinationLocation: {
                                x: left, y: top_1
                            },
                            zoomValue: annotation.ZoomValue,
                            url: annotation.Url,
                            strokeColor: this.pdfViewer.annotation.rgbaToHex(annotation.StrokeColor),
                            thickness: annotation.Thickness,
                            subject: annotation.Subject,
                            status: !isNullOrUndefined(annotation.Status) ? annotation.Status : status_1
                        };
                        var annot = {
                            id: annotId, annotationIndex: annotation.AnnotationIndex, shapeAnnotationType: 'Link', annotName: linkAnnotation.annotName,
                            bounds: {
                                x: linkAnnotation.bounds.left, y: linkAnnotation.bounds.top,
                                width: linkAnnotation.bounds.width, height: linkAnnotation.bounds.height
                            },
                            subject: linkAnnotation.subject,
                            strokeColor: linkAnnotation.strokeColor,
                            thickness: linkAnnotation.thickness,
                            destinationPageIndex: linkAnnotation.destinationPageIndex,
                            destinationLocation: linkAnnotation.destinationLocation,
                            zoomValue: linkAnnotation.zoomValue,
                            url: linkAnnotation.url,
                            pageIndex: linkAnnotation.pageNumber,
                            status: !isNullOrUndefined(annotation.Status) ? annotation.Status : status_1
                        };
                        var addedAnnot = this.pdfViewer.add(annot);
                        // Store annotation in the annotation collection
                        this.pdfViewer.annotation.storeAnnotations(pageNumber, linkAnnotation, '_annotations_link');
                        // Render clickable hyperlink element using LinkAnnotation's rendering methods.
                        // Pass a per-annotation id prefix so each link annotation gets a unique DOM id
                        // and the per-page index-0 collision (which previously caused only the first
                        // link to render) is avoided.
                        this.renderLinkElement(linkAnnotation, pageNumber, annotId);
                        if (this.isAddAnnotationProgramatically) {
                            var settings = {
                                opacity: annot.opacity, strokeColor: annot.strokeColor, thickness: annot.thickness,
                                width: annot.bounds.width, height: annot.bounds.height
                            };
                            this.pdfViewer.fireAnnotationAdd(annot.pageIndex, annot.annotName, annotation.ShapeAnnotationType, annot.bounds, settings);
                        }
                    }
                }
            }
            else if (linkAnnotations.shapeAnnotationType) {
                var annotationObject = this.createAnnotationObject(linkAnnotations);
                this.pdfViewer.annotationModule.storeAnnotations(pageNumber, annotationObject, '_annotations_link');
                this.pdfViewer.annotationModule.triggerAnnotationAdd(linkAnnotations);
            }
        }
    };
    PdfLinkAnnotation.prototype.createAnnotationObject = function (annotationModel) {
        var bound;
        var destinationBounds;
        var annotationName = this.pdfViewer.annotation.createGUID();
        annotationModel.annotName = annotationName;
        if (annotationModel.wrapper.bounds) {
            bound = {
                left: annotationModel.wrapper.bounds.x, top: annotationModel.wrapper.bounds.y,
                height: annotationModel.wrapper.bounds.height, width: annotationModel.wrapper.bounds.width,
                right: annotationModel.wrapper.bounds.right, bottom: annotationModel.wrapper.bounds.bottom
            };
        }
        else {
            bound = { left: 0, top: 0, height: 0, width: 0, right: 0, bottom: 0 };
        }
        if (annotationModel.destinationLocation) {
            destinationBounds = {
                x: annotationModel.destinationLocation.x, y: annotationModel.destinationLocation.y
            };
        }
        else {
            destinationBounds = { x: 0, y: 0 };
        }
        return {
            id: annotationModel.id, shapeAnnotationType: 'Link',
            subject: annotationModel.subject, destinationPageIndex: annotationModel.destinationPageIndex,
            destinationLocation: destinationBounds, zoomValue: annotationModel.zoomValue,
            strokeColor: annotationModel.strokeColor, annotName: annotationName,
            thickness: annotationModel.thickness, pageNumber: annotationModel.pageIndex,
            bounds: bound, status: AnnotationStatus.NewlyAdded
        };
    };
    /**
     * @param {ILinkAnnotation} linkAnnotation - It describes about the link annotation
     * @param {number} pageNumber - It describes about the page number
     * @param {string} idPrefix - idPrefix of link annotation
     * @private
     * @returns {void} - void
     */
    PdfLinkAnnotation.prototype.renderLinkElement = function (linkAnnotation, pageNumber, idPrefix) {
        var linkAnnotationModule = this.pdfViewer.linkAnnotationModule;
        if (isNullOrUndefined(linkAnnotationModule)) {
            return;
        }
        if (!isNullOrUndefined(linkAnnotation.url) && linkAnnotation.url.trim() !== '') {
            // For URL-based links, use renderWebLink
            // Convert bounds to format expected by renderWebLink
            var rect = linkAnnotation.bounds;
            var hyperlinksBounds = {
                Left: rect.left,
                Top: rect.top,
                Width: rect.width,
                Height: rect.height
            };
            linkAnnotationModule.renderWebLink([linkAnnotation.url], [hyperlinksBounds], pageNumber, idPrefix);
        }
        else if (!isNullOrUndefined(linkAnnotation.destinationPageIndex)) {
            // For document links, use renderDocumentLink
            var rect = linkAnnotation.bounds;
            var linkAnnotationBounds = {
                Left: rect.left,
                Top: rect.top,
                Width: rect.width,
                Height: rect.height
            };
            var destPageIndex = linkAnnotation.destinationPageIndex;
            // destinationLocation uses top-down (CSS) coordinates.
            // renderDocumentLink expects bottom-origin PDF coordinates (server convention),
            // so convert: bottomOriginY = destPageHeight - topDownY
            var destPageSize = this.pdfViewerBase.pageSize[parseInt(destPageIndex.toString(), 10)];
            var destPageHeight = destPageSize ? destPageSize.height : 0;
            var topDownY = linkAnnotation.destinationLocation && linkAnnotation.destinationLocation.y !== undefined ?
                linkAnnotation.destinationLocation.y : 0;
            var annotationY = topDownY === 0 ? 0 : destPageHeight - topDownY;
            var annotationX = linkAnnotation.destinationLocation && linkAnnotation.destinationLocation.x !== undefined ?
                linkAnnotation.destinationLocation.x : 0;
            linkAnnotationModule.renderDocumentLink([linkAnnotationBounds], [destPageIndex], [annotationY], pageNumber, [annotationX], [linkAnnotation.zoomValue], idPrefix);
        }
    };
    /**
     * @param {any} annotation - It describes about the annotation
     * @param {number} pageNumber - It describes about the page number
     * @private
     * @returns {any} - any
     */
    PdfLinkAnnotation.prototype.saveImportedlinkAnnotations = function (annotation, pageNumber) {
        var annotationObject = null;
        var left = !isNullOrUndefined(annotation.destinationLocation) ?
            (!isNullOrUndefined(annotation.destinationLocation.X) ? annotation.destinationLocation.X :
                annotation.destinationLocation.x) : undefined;
        var top = !isNullOrUndefined(annotation.destinationLocation) ?
            (!isNullOrUndefined(annotation.destinationLocation.Y) ? annotation.destinationLocation.Y :
                annotation.destinationLocation.y) : undefined;
        annotationObject = {
            id: 'link', shapeAnnotationType: annotation.ShapeAnnotationType, subject: annotation.Subject, pageNumber: pageNumber, strokeColor: annotation.StrokeColor, thickness: annotation.Thickness,
            bounds: {
                left: annotation.Bounds.X, top: annotation.Bounds.Y, width: annotation.Bounds.Width,
                height: annotation.Bounds.Height, right: annotation.Bounds.Right, bottom: annotation.Bounds.Bottom
            }, annotName: annotation.AnnotName,
            destinationPageIndex: annotation.DestinationPageIndex,
            destinationLocation: {
                x: left, y: top
            },
            zoomValue: annotation.ZoomValue,
            url: annotation.Url, status: annotation.status,
            annotationIndex: annotation.AnnotationIndex
        };
        this.pdfViewer.annotationModule.storeAnnotations(pageNumber, annotationObject, '_annotations_link');
    };
    /**
     * @private
     * @returns {string} - string
     */
    PdfLinkAnnotation.prototype.saveLinkAnnotations = function () {
        var storeObject = this.pdfViewer.annotationsCollection.get(this.pdfViewerBase.documentId + '_annotations_link');
        var annotations = [];
        for (var j = 0; j < this.pdfViewerBase.pageCount; j++) {
            annotations[parseInt(j.toString(), 10)] = [];
        }
        if (storeObject && !this.pdfViewer.annotationSettings.skipDownload) {
            var annotationCollection = JSON.parse(JSON.stringify(storeObject));
            for (var i = 0; i < annotationCollection.length; i++) {
                var newArray = [];
                var pageAnnotationObject = annotationCollection[parseInt(i.toString(), 10)];
                if (pageAnnotationObject) {
                    for (var z = 0; pageAnnotationObject.annotations.length > z; z++) {
                        if (!this.pdfViewerBase.checkFormFieldCollection(pageAnnotationObject.annotations[parseInt(z.toString(), 10)].id)) {
                            if (this.pdfViewer.printModule && this.pdfViewer.printModule.canPrint &&
                                pageAnnotationObject.annotations[parseInt(z.toString(), 10)].isPrint === false) {
                                pageAnnotationObject.annotations.splice(parseInt(z.toString(), 10), 1);
                                z--;
                                continue;
                            }
                            if (this.pdfViewerBase.isJsonExported) {
                                var pageDetails = this.pdfViewerBase.pageSize[pageAnnotationObject.pageIndex];
                                if (pageDetails) {
                                    pageAnnotationObject.annotations[parseInt(z.toString(), 10)].annotationRotation =
                                        pageDetails.rotation;
                                }
                            }
                            pageAnnotationObject.annotations[parseInt(z.toString(), 10)].bounds =
                                JSON.stringify(this.pdfViewer.annotation.getBounds(pageAnnotationObject.
                                    annotations[parseInt(z.toString(), 10)].bounds, pageAnnotationObject.pageIndex));
                            if (!isNullOrUndefined(pageAnnotationObject.annotations[parseInt(z.toString(), 10)].destinationLocation) &&
                                !isNullOrUndefined(pageAnnotationObject.annotations[parseInt(z.toString(), 10)].destinationPageIndex)) {
                                pageAnnotationObject.annotations[parseInt(z.toString(), 10)].destinationLocation =
                                    JSON.stringify(this.pdfViewer.annotation.getLocation(pageAnnotationObject.
                                        annotations[parseInt(z.toString(), 10)].destinationLocation, pageAnnotationObject.
                                        annotations[parseInt(z.toString(), 10)].destinationPageIndex));
                            }
                            var strokeColorString = pageAnnotationObject.annotations[parseInt(z.toString(), 10)].strokeColor;
                            pageAnnotationObject.annotations[parseInt(z.toString(), 10)].strokeColor =
                                JSON.stringify(this.getRgbCode(strokeColorString));
                        }
                        else {
                            pageAnnotationObject.annotations[parseInt(z.toString(), 10)] = '';
                        }
                    }
                    pageAnnotationObject.annotations = pageAnnotationObject.annotations.filter(function (item) { return item; });
                    newArray = pageAnnotationObject.annotations;
                }
                annotations[pageAnnotationObject.pageIndex] = newArray;
            }
            annotationCollection = null;
        }
        return JSON.stringify(annotations);
    };
    PdfLinkAnnotation.prototype.getRgbCode = function (colorString) {
        // eslint-disable-next-line
        if (!colorString.match(/#([a-z0-9]+)/gi) && !colorString.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)) {
            colorString = this.pdfViewer.annotationModule.nameToHash(colorString);
        }
        var stringArray = colorString.split(',');
        if (isNullOrUndefined(stringArray[1])) {
            colorString = this.pdfViewer.annotationModule.getValue(colorString, 'rgba');
            stringArray = colorString.split(',');
        }
        var r = parseInt(stringArray[0].split('(')[1], 10);
        var g = parseInt(stringArray[1], 10);
        var b = parseInt(stringArray[2], 10);
        var a = parseFloat(stringArray[3]);
        return { r: r, g: g, b: b, a: a };
    };
    /**
     * Remove all existing <a> link elements for a given page from the DOM,
     * then re-render every stored link annotation for that page.
     * Called after editAnnotation updates a link annotation so the onclick handler reflects new values.
     * @param {number} pageNumber - The 0-based page index.
     * @private
     * @returns {void}
     */
    PdfLinkAnnotation.prototype.refreshLinkElements = function (pageNumber) {
        var pageDiv = document.getElementById(this.pdfViewer.element.id + '_pageDiv_' + pageNumber);
        if (pageDiv) {
            // Remove all document-link and web-link <a> elements for this page
            var anchors = pageDiv.getElementsByTagName('a');
            var toRemove = [];
            for (var i = 0; i < anchors.length; i++) {
                var anchor = anchors[parseInt(i.toString(), 10)];
                var id = anchor.id || '';
                if (id.indexOf('linkdiv_') !== -1 || id.indexOf('weblinkdiv_') !== -1) {
                    toRemove.push(anchor);
                }
            }
            for (var i = 0; i < toRemove.length; i++) {
                toRemove[parseInt(i.toString(), 10)].parentNode.removeChild(toRemove[parseInt(i.toString(), 10)]);
            }
        }
        // Re-render all stored link annotations for this page
        this.rerenderStoredLinkElements(pageNumber);
    };
    /**
     * Re-render stored link elements for a page after it is recreated by virtualization.
     * Called from onPageRender whenever a pageDiv is (re)added to the DOM.
     * @param {number} pageNumber - The 0-based page index whose link elements need re-rendering.
     * @private
     * @returns {void}
     */
    PdfLinkAnnotation.prototype.rerenderStoredLinkElements = function (pageNumber) {
        var storeObject = this.pdfViewer.annotationsCollection.get(this.pdfViewerBase.documentId + '_annotations_link');
        if (!storeObject) {
            return;
        }
        var index = this.pdfViewer.annotationModule.getPageCollection(storeObject, pageNumber);
        if (isNullOrUndefined(index) || !storeObject[parseInt(index.toString(), 10)]) {
            return;
        }
        var annotations = storeObject[parseInt(index.toString(), 10)].annotations;
        if (!annotations || annotations.length === 0) {
            return;
        }
        for (var i = 0; i < annotations.length; i++) {
            var storedAnnot = annotations[parseInt(i.toString(), 10)];
            this.renderLinkElement(storedAnnot, pageNumber, storedAnnot.id);
        }
    };
    /**
     * Delete a link annotation from the store and the DOM by its annotName (annotation ID).
     * Removes the entry from _annotations_link, clears the <a> elements for the page,
     * and re-renders remaining link annotations.
     * @param {any} annotation - annotation
     * @returns {void} - true if a matching annotation was found and deleted, false otherwise.
     * @private
     */
    PdfLinkAnnotation.prototype.deleteLinkAnnotationById = function (annotation) {
        this.pdfViewer.annotationModule.updateImportAnnotationCollection(annotation, annotation.pageIndex, 'linkAnnotation');
        var undoElement = this.modifyInCollections(annotation, 'delete');
        this.pdfViewer.annotation.addAction(annotation.pageIndex, null, annotation, 'Link Delete', '', undoElement, annotation);
        this.pdfViewer.annotationModule.updateAnnotationCollection(annotation);
        this.pdfViewer.remove(annotation);
        this.pdfViewer.renderDrawing();
        this.pdfViewer.clearSelection(annotation.pageIndex);
        this.pdfViewerBase.updateDocumentEditedProperty(true);
        this.pdfViewer.fireAnnotationRemove(annotation.pageIndex, annotation.annotationId, 'Link', annotation.bounds);
        if (this.pdfViewer.toolbarModule) {
            this.pdfViewer.toolbarModule.updateUndoRedoButtons();
        }
        if (this.pdfViewer.annotationModule.actionCollection && this.pdfViewer.annotationModule.actionCollection.length === 0) {
            this.pdfViewerBase.updateDocumentEditedProperty(false);
        }
        else {
            this.pdfViewerBase.updateDocumentEditedProperty(true);
        }
        this.pdfViewerBase.updateDocumentEditedProperty(true);
    };
    /**
     * @param {PdfAnnotationBaseModel} annotation - annotation
     * @param {string} property - property
     * @private
     * @returns {any} - any
     */
    PdfLinkAnnotation.prototype.modifyInCollections = function (annotation, property) {
        var currentAnnotObject = null;
        var pageAnnotations = this.getAnnotations(annotation.pageIndex, null);
        if (pageAnnotations != null && annotation) {
            for (var i = 0; i < pageAnnotations.length; i++) {
                if (annotation.id === pageAnnotations[parseInt(i.toString(), 10)].id) {
                    if (property === 'bounds') {
                        this.pdfViewerBase.isBounds =
                            this.pdfViewerBase.boundsCalculation(pageAnnotations[parseInt(i.toString(), 10)].bounds, annotation.wrapper.bounds);
                        if (this.pdfViewerBase.isBounds) {
                            pageAnnotations[parseInt(i.toString(), 10)].bounds = {
                                left: annotation.bounds.x,
                                top: annotation.bounds.y, width: annotation.bounds.width,
                                height: annotation.bounds.height, right: annotation.bounds.right,
                                bottom: annotation.bounds.bottom
                            };
                        }
                    }
                    else if (property === 'stroke') {
                        pageAnnotations[parseInt(i.toString(), 10)].strokeColor = annotation.wrapper.children[0].style.strokeColor;
                    }
                    else if (property === 'thickness') {
                        pageAnnotations[parseInt(i.toString(), 10)].thickness = annotation.wrapper.children[0].style.strokeWidth;
                    }
                    else if (property === 'url') {
                        pageAnnotations[parseInt(i.toString(), 10)].url = annotation.url;
                    }
                    else if (property === 'destinationPageIndex') {
                        pageAnnotations[parseInt(i.toString(), 10)].destinationPageIndex = annotation.destinationPageIndex;
                    }
                    else if (property === 'destinationLocation') {
                        if (!isNullOrUndefined(annotation.destinationLocation)) {
                            pageAnnotations[parseInt(i.toString(), 10)].destinationLocation = {
                                x: annotation.destinationLocation.x,
                                y: annotation.destinationLocation.y
                            };
                        }
                    }
                    else if (property === 'zoomValue') {
                        pageAnnotations[parseInt(i.toString(), 10)].zoomValue = annotation.zoomValue;
                    }
                    else if (property === 'delete') {
                        currentAnnotObject = pageAnnotations.splice(i, 1)[0];
                        break;
                    }
                    if (pageAnnotations[parseInt(i.toString(), 10)].status !== 'NewlyAdded') {
                        pageAnnotations[parseInt(i.toString(), 10)].status = AnnotationStatus.ExistingModified;
                    }
                    this.pdfViewer.annotationModule.storeAnnotationCollections(pageAnnotations[parseInt(i.toString(), 10)], annotation.pageIndex);
                }
            }
            this.manageAnnotations(pageAnnotations, annotation.pageIndex);
        }
        if (this.pdfViewer.annotationModule.isUndoRedoAction && property === 'delete') {
            this.pdfViewer.annotationModule.updateAnnotationCollection(annotation);
        }
        this.refreshLinkElements(annotation.pageIndex);
        return currentAnnotObject;
    };
    PdfLinkAnnotation.prototype.getAnnotations = function (pageIndex, linkAnnotations) {
        var annotationCollection;
        var storeObject = this.pdfViewer.annotationsCollection.get(this.pdfViewerBase.documentId + '_annotations_link');
        if (storeObject) {
            var index = this.pdfViewer.annotationModule.getPageCollection(storeObject, pageIndex);
            if (index != null && storeObject[parseInt(index.toString(), 10)]) {
                annotationCollection = storeObject[parseInt(index.toString(), 10)].annotations;
            }
            else {
                annotationCollection = linkAnnotations;
            }
        }
        else {
            annotationCollection = linkAnnotations;
        }
        return annotationCollection;
    };
    PdfLinkAnnotation.prototype.manageAnnotations = function (pageAnnotations, pageNumber) {
        var storeObject = this.pdfViewer.annotationsCollection.get(this.pdfViewerBase.documentId + '_annotations_link');
        if (storeObject) {
            this.pdfViewer.annotationsCollection.delete(this.pdfViewerBase.documentId + '_annotations_link');
            var index = this.pdfViewer.annotationModule.getPageCollection(storeObject, pageNumber);
            if (index != null && storeObject[parseInt(index.toString(), 10)]) {
                storeObject[parseInt(index.toString(), 10)].annotations = pageAnnotations;
            }
            this.pdfViewer.annotationsCollection.set(this.pdfViewerBase.documentId + '_annotations_link', storeObject);
        }
    };
    /**
     * @param {number} pageNumber - It describes about the page number
     * @param {ILinkAnnotation} annotationBase - It describes about the annotation base
     * @private
     * @returns {void}
     */
    PdfLinkAnnotation.prototype.addInCollection = function (pageNumber, annotationBase) {
        var pageAnnotations = this.getAnnotations(pageNumber, null);
        if (pageAnnotations) {
            pageAnnotations.push(annotationBase);
        }
        this.manageAnnotations(pageAnnotations, pageNumber);
    };
    /**
     * @param {any} annotation - It describes about the annotation
     * @param {number} pageNumber - It describes about the page number
     * @private
     * @returns {any} - any
     */
    PdfLinkAnnotation.prototype.updateLinkAnnotationCollections = function (annotation, pageNumber) {
        var annotationObject = null;
        annotationObject = {
            id: 'link', shapeAnnotationType: annotation.ShapeAnnotationType, annotationIndex: annotation.AnnotationIndex,
            subject: annotation.Subject, strokeColor: annotation.StrokeColor,
            thickness: annotation.Thickness, annotationId: annotation.AnnotName,
            bounds: { left: annotation.Bounds.X, top: annotation.Bounds.Y, width: annotation.Bounds.Width,
                height: annotation.Bounds.Height, right: annotation.Bounds.Right, bottom: annotation.Bounds.Bottom },
            pageNumber: pageNumber, destinationLocation: { x: !isNullOrUndefined(annotation.destinationLocation) ?
                    annotation.destinationLocation.X : null, y: !isNullOrUndefined(annotation.destinationLocation) ?
                    annotation.destinationLocation.Y : null }, destinationPageIndex: annotation.DestinationPageIndex,
            url: annotation.Url, zoomValue: annotation.ZoomValue
        };
        return annotationObject;
    };
    /**
     * @private
     * @returns {void}
     */
    PdfLinkAnnotation.prototype.destroy = function () {
        this.linkAnnotationCount = null;
        this.isAddAnnotationProgramatically = null;
    };
    /**
     * @param {string} annotationType - It describes about the type of the annotation
     * @private
     * @returns {boolean} - boolean
     */
    PdfLinkAnnotation.prototype.isLinkAnnotation = function (annotationType) {
        return annotationType === 'Link';
    };
    return PdfLinkAnnotation;
}());
export { PdfLinkAnnotation };
